$(document).ready(function () {
    //Product page carousel with synced nav carousel
    var syncMain = $(".product-page-carousel");
    var syncNav = $(".product-page-carousel-nav");

    var thumbnailItemClass = '.owl-item';

    var slides = syncMain.owlCarousel({
        video: true,
        startPosition: 12,
        items: 1,
        loop: true,
        margin: 10,
        autoplay: false,
        autoplayTimeout: 6000,
        autoplayHoverPause: false,
        nav: false,
        dots: false
    }).on('changed.owl.carousel', syncPosition);

    function syncPosition(el) {
        $owl_slider = $(this).data('owl.carousel');
        var loop = $owl_slider.options.loop;

        if (loop) {
            var count = el.item.count - 1;
            var current = Math.round(el.item.index - (el.item.count / 2) - .5);
            if (current < 0) {
                current = count;
            }
            if (current > count) {
                current = 0;
            }
        } else {
            var current = el.item.index;
        }

        var owl_thumbnail = syncNav.data('owl.carousel');
        var itemClass = "." + owl_thumbnail.options.itemClass;

        var thumbnailCurrentItem = syncNav
            .find(itemClass)
            .removeClass("synced")
            .eq(current);

        thumbnailCurrentItem.addClass('synced');

        if (!thumbnailCurrentItem.hasClass('active')) {
            var duration = 300;
            syncNav.trigger('to.owl.carousel', [current, duration, true]);
        }
    }
    var thumbs = syncNav.owlCarousel({
        startPosition: 12,
        items: 3,
        loop: false,
        margin: 10,
        autoplay: false,
        nav: false,
        dots: true,
        responsive: {
            768: {
                items: 4,
            },
        },
        onInitialized: function (e) {
            var thumbnailCurrentItem = $(e.target).find(thumbnailItemClass).eq(this._current);
            thumbnailCurrentItem.addClass('synced');
        },
    })
        .on('click', thumbnailItemClass, function (e) {
            e.preventDefault();
            var duration = 300;
            var itemIndex = $(e.target).parents(thumbnailItemClass).index();
            syncMain.trigger('to.owl.carousel', [itemIndex, duration, true]);
        })
        .on('focus', thumbnailItemClass, function (e) {
            var itemIndex = $(e.target).parents(thumbnailItemClass).index();
            $owl_slider = syncMain.data('owl.carousel');
            $owl_slider.to(itemIndex, 100, true);
        })
        .on("changed.owl.carousel", function (el) {
            var number = el.item.index;
            $owl_slider = syncMain.data('owl.carousel');
            $owl_slider.to(number, 100, true);
        });

    //Featured product carousel
    $productCarousel = $('.product-carousel').owlCarousel({
        loop: true,
        margin: 5,
        nav: false,
        items: 2.5,
        stagePadding: 0,
        navText: ["<span class='icon-chevron-left text-light'>", "<span class='icon-chevron-right text-light'>"],
        responsive: {
            0: {
                items: 1.5,
                dots: false,
                nav: false
            },
            460: {
                items: 2.5,
                dots: false,
                nav: false,
                margin: 10,
            },
            1200: {
                stagePadding: 0,
                margin: 30,
                items: 3.5,
                dots: false
            },
            1320: {
                stagePadding: 0,
                margin: 30,
                items: 4.5,
                dots: false
            }
        }
    });

    //Product carousel sidebar
    $('.product-carousel-sidebar').owlCarousel({
        //loop: true,
        margin: 0,
        nav: false,
        stagePadding: 0,
        navText: ["<span class='icon-chevron-left'>", "<span class='icon-chevron-right'>"],
        responsive: {
            0: {
                items: 2,
                dots: false,
            },
            768: {
                items: 3,
                dots: false,
                nav: true,
                margin: 15,
            },
            // 1200: {
            //     stagePadding: 0,
            //     margin: 10,
            //     items: 2.5,
            //     dots: false
            // },
            // 1320: {
            //     stagePadding: 0,
            //     margin: 10,
            //     items: 3.5,
            //     dots: false
            // }
        }
    });

    //Featured blog carousel
    $('.blog-carousel').owlCarousel({
        loop: true,
        margin: 15,
        nav: true,
        navText: ["<span class='icon-chevron-left text-dark'>", "<span class='icon-chevron-right text-dark'>"],
        responsive: {
            0: {
                items: 1.5,
                dots: true,
                nav: false
            },
            768: {
                items: 2,
                dots: false,
                nav: true,
                margin: 10
            },
            1200: {
                margin: 10,
                items: 3,
                dots: false
            },
            1320: {
                margin: 10,
                items: 4,
                dots: false
            }
        }
    });


    function moveCarouselItems() {
        var carousels = $('.section-carousel')

        carousels.each(function (index, carousel) {

            var buttons = $(carousel).find($('.owl-nav'))
            var section = $(carousel).find($('.section-carousel__intro'));
            var button = $(carousel).find($('.carousel__view-all'))

            section.append(button)
            section.append(buttons)
        })
    }

    function moveCarouselItemsMobile() {
        var carousels = $('.section-carousel')

        carousels.each(function (index, carousel) {

            var nav = $(carousel).find($('.owl-nav'))
            var c = $(carousel).find($('.owl-carousel'));
            var buttonOuter = $(carousel).find($('.carousel__view-all'))
            var button = $(carousel).find($('.carousel__view-all a'))

            button.removeClass('button--primary')
            button.addClass('button--secondary')

            c.append(nav)
            c.append(buttonOuter)

        })
    }

    function editNavigationButtons() {
      console.log("EDIT NAVIGATION BUTTONS");
      var carousels = $('.section-carousel');
      carousels.each(function (index, carousel) {
        var prev = $(this).find($(".owl-prev"));
        var next = $(this).find($(".owl-next"));

        prev.removeAttr("role");
        prev.attr("aria-label", "Previous");
        
        next.removeAttr("role");
        next.attr("aria-label", "Next");
      });
    }
  
    $("owl-nav").ready(function () {
        if ($(window).width() < 767) {
            moveCarouselItemsMobile();
        } else {
            moveCarouselItems();
        }
        editNavigationButtons();
    })


    $(window).resize(function () {
        if ($(window).width() < 767) {
            debounce(moveCarouselItemsMobile(), 1000)
        } else {
            debounce(moveCarouselItems(), 1000)
        }
    })
})